const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* === TBO stat-bar declutter (#tbo-ps): show Orders / Rating / Delivery only === */
/* Uses #tbo-ps>div:nth-child(...) [higher specificity] to beat the theme's own */
/* #tbo-ps .pi{display:flex!important}. Reversible: delete this block. */
;(function(){try{
  var css='#tbo-ps>div:nth-child(5),#tbo-ps>div:nth-child(6),#tbo-ps>div:nth-child(8),#tbo-ps>div:nth-child(9){display:none!important}'
    +'@media(max-width:600px){#tbo-ps{grid-template-columns:repeat(3,1fr)!important}#tbo-ps .sep{display:none!important}}'
    +'@media(max-width:480px){#tbo-ps{grid-template-columns:repeat(3,1fr)!important}}';
  var s=document.createElement('style');s.id='tbo-statbar-trim';s.textContent=css;
  (document.head||document.documentElement).appendChild(s);
}catch(e){}})();

/* === TBO signup consolidation: make the $10 popup the single email capture === */
/* Hides the red 'Subscribe to receive updates' newsletter section + footer CTA. */
/* Real JSON-template section id + suffix fallback; #tbo-ff[id] beats the theme's */
/* #tbo-ff{display:flex!important}. Reversible: delete this block. */
;(function(){try{
  var css='#shopify-section-template--27175342965011__new_newsletter_UyRz3T,[id$="__new_newsletter_UyRz3T"]{display:none!important}'
    +'#tbo-ff[id],#tbo-fc3[id]{display:none!important}';
  var s=document.createElement('style');s.id='tbo-signup-consolidate';s.textContent=css;
  (document.head||document.documentElement).appendChild(s);
}catch(e){}})();

/* === TBO P0 cleanup: trust + accuracy === */
/* Removes fabricated/redundant merchandising so the store reads honest + premium: */
/*   .tbo-sc3 / .tbo-scarcity  = fake 'Only N left' scarcity on collection cards */
/*   #tbo-val-badges           = leftover auto value badges on PDP (streamline missed) */
/*   #tbo-trust-grid           = duplicate trust row on PDP (keeps the v4 #tbo-trust) */
/*   .tbo-flavor-tags          = auto-generated tasting notes (JUDGMENT CALL - delete */
/*                               this one line to bring them back; real notes belong */
/*                               in product metafields, not keyword guesses) */
/* [class]/[id] used to outrank the theme's own !important rules. Reversible. */
;(function(){try{
  var css='.tbo-sc3[class],.tbo-scarcity[class]{display:none!important}'
    +'#tbo-val-badges[id]{display:none!important}'
    +'#tbo-trust-grid[id]{display:none!important}'
    +'.tbo-flavor-tags[class]{display:none!important}';
  var s=document.createElement('style');s.id='tbo-p0-cleanup';s.textContent=css;
  (document.head||document.documentElement).appendChild(s);
}catch(e){}})();
